import React from "react";
import { Api } from "../app-controller.js";

const card = {
  background: "#222",
  border: "1px solid #093EA3",
  color: "rgba(250, 250, 250, 0.8)",
  marginBottom: "2rem",
  width: "18rem",
};

const btn = {
  border: "5px solid",
  borderImageSlice: 1,
  background: "linear-gradient(to left top, #093EA3 10%, #08AAC1 90%)",
  borderImageSource: "linear-gradient(to left top, #093EA3 10%, #08AAC1 90%)",
  textDecoration: "none",
  tansition: "all .4s ease",
};

class MoveProducts extends React.Component {
  initialState = {
    nivelUsuario: localStorage.nivel_actual,
    usuario_id: JSON.parse(localStorage.user).id || null,
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  componentDidMount() {
    // si el usuario no es nivel cliente redireccionamos a home
    if (!["5"].includes(this.state.nivelUsuario)) {
      window.location.href = "/";
    }
  }

  render() {
    return (
      <fieldset className="panel">
        <legend>Descargar aplicación móvil</legend>
        <div className="container">
          <div className="row">
            <div className="col-md-12 p-4">
              <div className="card m-auto" style={card}>
                <img
                  src="../assets/logo.png"
                  className="card-img-top"
                  alt="logo sinap"
                />
                <div className="card-body text-center">
                  <h5 className="card-title">Aplicación móvil SINAIP</h5>
                  <h6 className="card-subtitle mb-2 text-muted">
                    <b>Ver.</b> 1.7.7
                  </h6>
                  <p className="card-text">
                    <b>Última actualización: </b> 06/01/2022 04:24
                  </p>
                  <a
                    className="btn btn-block"
                    id="btn-apk"
                    rel="noopener noreferrer"
                    href={
                      Api.url +
                      `app/descargarApk?u=${this.state.usuario_id}&n=${this.state.nivelUsuario}`
                    }
                    style={btn}
                  >
                    <i className="fas fa-arrow-circle-down"></i> Descargar apk
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    );
  }
}

export default MoveProducts;
